import { Box, BoxProps } from '@rossum/ui/material';

export type SeparatorContainerProps = BoxProps & {
  orientation: 'horizontal' | 'vertical';
};

export const SeparatorContainer = ({
  orientation,
  ...props
}: SeparatorContainerProps) => {
  const primaryDim = orientation === 'horizontal' ? 'width' : 'height';
  return (
    <Box
      {...props}
      sx={{ position: 'absolute', [primaryDim]: '100%', ...props.sx }}
    />
  );
};
